export const readStored = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const writeStored = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    return;
  }
};

export const removeStored = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch {
    return;
  }
};

export const readStoredJson = (key: string): unknown => {
  const stored = readStored(key);
  if (!stored) return undefined;

  try {
    return JSON.parse(stored);
  } catch {
    return undefined;
  }
};

export const writeStoredJson = (key: string, value: unknown): void => writeStored(key, JSON.stringify(value));
